import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import { CModal } from '@coreui/react';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const InstituteUploadReferenceBook = () => {
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload();
    const instituteMasterId = localStorage.getItem("instituteMasterId")
    const pdfFile = useRef(null);
    const initialFormState = {
        instituteMasterId: instituteMasterId,
        filePath: '',
        fileName: "",
        title: '',
        description: '',
        tagMasterId: "",
        instituteGradeMasterIds: [''],
        instituteStreamormediumMappingId: '',
        instituteBoardMappingId: ''
    }

    const [formData, setFormData] = useState([])
    const [PdfBookData, setPdfBookData] = useState(initialFormState)
    const [PdfBookList, setPdfBookList] = useState([])
    const [gradeList, setGradeList] = useState([])
    const [tag, setTag] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState("")

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [boardSort, setBoardSort] = useState(null);
    const [mediumSort, setMediumSort] = useState(null);
    const [pdfTitleSort, setPdfTitleSort] = useState(null);
    const [pdfDescriptionSort, setPdfDescriptionSort] = useState(null);
    const [tagNameSort, setTagNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["instituteBoardMappingDetails.boardMasterDetails.boardName", "instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName", "instituteReferenceBookMasterDetails.instituteGradeMasterDetails.gradeName", "tagMasterDetails.tagName", "fileName", "title", "description"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getBoard();
        getGrade();
        getTag();
    }, []);

    const getBoard = () => {
        const apiUrl = `/institute-wise-board-stream?instituteId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setFormData(response.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getGrade = () => {
        const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result.map((sub) => {
                    return {
                        value: sub.id,
                        label: sub.gradeName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getTag = () => {
        const apiUrl = `/get-institute-tag-master?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setTag(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getReferenceBookList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (PdfBookData.instituteBoardMappingId.length !== 0) {
                setCurrPage(1);
                setPdfBookList(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(PdfBookList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(PdfBookList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > PdfBookList.length) {
            endIndex = PdfBookList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(PdfBookList.slice(startIndex, endIndex));
    }, [PdfBookList, currPage, itemsPerPage]);

    useEffect(() => {
        if (PdfBookData.instituteBoardMappingId.length !== 0) {
            getReferenceBookList();
        }
    }, [PdfBookData]);

    const getApiUrl = () => {
        let apiUrl = '/get-institute-reference-book?';
        if (PdfBookData.instituteMasterId !== '') {
            apiUrl += `instituteMasterId=${PdfBookData.instituteMasterId}&`;
        }
        if (PdfBookData.tagMasterId !== '') {
            apiUrl += `tagMasterId=${PdfBookData.tagMasterId}&`;
        }
        if (PdfBookData.instituteGradeMasterIds.length !== 0) {
            apiUrl += `instituteGradeMasterIds=${PdfBookData.instituteGradeMasterIds}&`;
        }
        if (PdfBookData.instituteStreamormediumMappingId !== '') {
            apiUrl += `instituteStreamormediumMappingId=${PdfBookData.instituteStreamormediumMappingId}&`;
        }
        if (PdfBookData.instituteBoardMappingId !== '') {
            apiUrl += `instituteBoardMappingId=${PdfBookData.instituteBoardMappingId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getReferenceBookList = async () => {
        if (PdfBookData.instituteBoardMappingId.length !== 0) {
            try {
                const response = await authorizedAxiosInstitute.get(getApiUrl());
                setPdfBookList(response.data.result);
            } catch (error) {
                setPdfBookList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(PdfBookData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [PdfBookData])

    const addLesson = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-institute-reference-book`;
                const response = await authorizedAxiosInstitute.post(apiUrl, PdfBookData);
                await getReferenceBookList();
                pdfFile.current.value = "";
                setPdfBookData((prevData) => {
                    return {
                        ...prevData,
                        filePath: '',
                        fileName: '',
                        title: '',
                        description: ''
                    }
                });

                setSaveId(response.data.result.id);
                setBoardSort(null);
                setMediumSort(null);
                setPdfTitleSort(null);
                setPdfDescriptionSort(null);
                setTagNameSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-institute-reference-book?id=${id}`;
                const response = await authorizedAxiosInstitute.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, PdfBookList.length);
                await getReferenceBookList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const handleUploadLogo = async (e) => {
        const { name, files } = e.target;
        if (!files || files.length === 0) {
            return; // Return early if no file is selected
        }

        const file = files[0];
        const fileName = file.name.split(".")[0];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const maxFileSize = 50 * 1024 * 1024; // 50 MB

        if (fileExtension !== "pdf") {
            e.target.value = '';
            return Swal.fire({ text: "Only PDF files are supported" });
        }

        if (file.size > maxFileSize) {
            e.target.value = '';
            return Swal.fire({ text: "Max size 50 MB file supported" });
        }

        setLoading(true);
        const body = new FormData();
        body.append("file", file);
        body.append("flag", "2");

        try {
            const apiUrl = "uploadfile-v2";
            const res = await authorizedAxiosCommonFileUpload.post(apiUrl, body);
            setPdfBookData((prevData) => ({
                ...prevData,
                [name]: res.data.result,
                fileName
            }));
        } catch (err) {
            console.log("Error: ", err);
        } finally {
            setLoading(false);
        }
    };


    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions?.map((option) => option.value.toString());
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                instituteGradeMasterIds: selectedIds,
            }
        })
    }

    const handleInputReset = () => {
        setPdfBookData(initialFormState);
        setEditId('');
        setPdfBookList([]);
        setError(initialErrorState);
        pdfFile.current.value = "";
    }

    useEffect(() => {
        if (boardSort == true || boardSort == false) {
            setMediumSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [boardSort])

    useEffect(() => {
        if (mediumSort == true || mediumSort == false) {
            setBoardSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [mediumSort])

    useEffect(() => {
        if (pdfTitleSort == true || pdfTitleSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfDescriptionSort(null);
            setTagNameSort(null);
        }
    }, [pdfTitleSort])

    useEffect(() => {
        if (pdfDescriptionSort == true || pdfDescriptionSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfTitleSort(null);
            setTagNameSort(null);
        }
    }, [pdfDescriptionSort])

    useEffect(() => {
        if (tagNameSort == true || tagNameSort == false) {
            setBoardSort(null);
            setMediumSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [tagNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Institute Reference Book</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-upload"></i> Institute Reference Book </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Board :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteBoardMappingId' onChange={handleInputChange} value={PdfBookData.instituteBoardMappingId}>
                                                        <option selected value={''} disabled>Select Board</option>
                                                        {
                                                            formData?.boards?.map((board) => {
                                                                return <option value={board.id}>{board.boardMasterDetails.boardName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteBoardMappingId && <p style={{ color: 'red' }}>{error.instituteBoardMappingId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Medium :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteStreamormediumMappingId' onChange={handleInputChange} value={PdfBookData.instituteStreamormediumMappingId}>
                                                        <option selected value={''} disabled>Select Medium</option>
                                                        {
                                                            formData?.streams?.map((stream) => {
                                                                return <option value={stream.id}>{stream.streamOrMediumMasterDetails.streamName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.instituteStreamormediumMappingId && <p style={{ color: 'red' }}>{error.instituteStreamormediumMappingId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={gradeList.filter(option =>
                                                            PdfBookData.instituteGradeMasterIds && PdfBookData.instituteGradeMasterIds.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="instituteGradeMasterIds"
                                                        options={gradeList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeBoard}
                                                    />
                                                    {error.instituteGradeMasterIds && <p style={{ color: 'red' }}>{error.instituteGradeMasterIds}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Tag :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='tagMasterId' onChange={handleInputChange} value={PdfBookData.tagMasterId}>
                                                        <option selected value={''} disabled>Select Tag</option>
                                                        {
                                                            tag?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.tagName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.tagMasterId && <p style={{ color: 'red' }}>{error.tagMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Refrence PDF Book :</label>
                                                    <label style={{ color: "red" }} > max 50 Mb pdf file supported</label>
                                                    <input required type="file" className="form-control" name="filePath" onChange={handleUploadLogo} ref={pdfFile} />
                                                    {error.filePath && <p style={{ color: 'red' }}>{error.filePath}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>File Name:</label>
                                                    <input required type="text" className="form-control" name="fileName" value={PdfBookData.fileName} onChange={handleInputChange} />
                                                    {error.fileName && <p style={{ color: 'red' }}>{error.fileName}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Title:</label>
                                                    <input required type="text" className="form-control" name="title" value={PdfBookData.title} onChange={handleInputChange} />
                                                    {error.title && <p style={{ color: 'red' }}>{error.title}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Description:</label>
                                                    <input required type="text" className="form-control" name="description" value={PdfBookData.description} onChange={handleInputChange} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>
                                            </div>

                                            <CModal
                                                visible={visible}
                                                onClose={() => setVisible(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                            >
                                                <div className="book pdf-modal">
                                                    {<iframe src={showPdfLink} width="800" height="1000"></iframe>}

                                                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                        Close
                                                    </button>
                                                </div>
                                            </CModal>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>
                                                        }
                                                        <button className="btn btn-outline-danger delete_icon" type="reset" style={{ marginRight: '20px' }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Board
                                                                            <SortIcon sortState={boardSort} setSortState={setBoardSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"instituteBoardMappingDetails.boardMasterDetails.boardName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Medium
                                                                            <SortIcon sortState={mediumSort} setSortState={setMediumSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"instituteStreamormediumMappingDetails.streamOrMediumMasterDetails.streamName"} />
                                                                        </th>
                                                                        <th scope="col">Class</th>
                                                                        <th scope="col">
                                                                            Tag Name
                                                                            <SortIcon sortState={tagNameSort} setSortState={setTagNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"tagMasterDetails.tagName"} />
                                                                        </th>
                                                                        <th scope="col">Book Name</th>
                                                                        <th scope="col">
                                                                            Book Title
                                                                            <SortIcon sortState={pdfTitleSort} setSortState={setPdfTitleSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Description
                                                                            <SortIcon sortState={pdfDescriptionSort} setSortState={setPdfDescriptionSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"description"} />
                                                                        </th>
                                                                        <th scope="col">Book</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson?.instituteBoardMappingDetails?.boardMasterDetails?.boardName}</td>
                                                                                        <td>{lesson?.instituteStreamormediumMappingDetails?.streamOrMediumMasterDetails?.streamName}</td>
                                                                                        <td>{lesson?.instituteReferenceBookMasterDetails?.map((i) => `${i?.instituteGradeMasterDetails?.gradeName} `)}</td>
                                                                                        <td>{lesson?.tagMasterDetails?.tagName}</td>
                                                                                        <td>{lesson?.fileName}</td>
                                                                                        <td>{lesson?.title}</td>
                                                                                        <td>{lesson?.description}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(lesson.filePath)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i> Book</button>
                                                                                        </td>

                                                                                        <td>

                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Reference Book Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={PdfBookList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default InstituteUploadReferenceBook;